const ImageData = [
  {
    id: 1,
    image:
      "https://images.pexels.com/photos/1297483/pexels-photo-1297483.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 2,
    image:
      "https://images.pexels.com/photos/3872626/pexels-photo-3872626.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 3,
    image:
      "https://images.pexels.com/photos/1229414/pexels-photo-1229414.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 4,
    image:
      "https://images.pexels.com/photos/1182963/pexels-photo-1182963.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 5,
    image:
      "https://images.pexels.com/photos/1253370/pexels-photo-1253370.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 6,
    image:
      "https://images.pexels.com/photos/936554/pexels-photo-936554.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 7,
    image:
      "https://images.pexels.com/photos/1516357/pexels-photo-1516357.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 8,
    image:
      "https://images.pexels.com/photos/2124728/pexels-photo-2124728.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 9,
    image:
      "https://images.pexels.com/photos/2377658/pexels-photo-2377658.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 10,
    image:
      "https://images.pexels.com/photos/2647744/pexels-photo-2647744.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 11,
    image:
      "https://images.pexels.com/photos/1297483/pexels-photo-1297483.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 12,
    image:
      "https://images.pexels.com/photos/3872626/pexels-photo-3872626.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 13,
    image:
      "https://images.pexels.com/photos/1229414/pexels-photo-1229414.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 14,
    image:
      "https://images.pexels.com/photos/1182963/pexels-photo-1182963.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 15,
    image:
      "https://images.pexels.com/photos/1253370/pexels-photo-1253370.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 16,
    image:
      "https://images.pexels.com/photos/936554/pexels-photo-936554.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 17,
    image:
      "https://images.pexels.com/photos/1516357/pexels-photo-1516357.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 18,
    image:
      "https://images.pexels.com/photos/2124728/pexels-photo-2124728.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 19,
    image:
      "https://images.pexels.com/photos/2377658/pexels-photo-2377658.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 20,
    image:
      "https://images.pexels.com/photos/2647744/pexels-photo-2647744.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 21,
    image:
      "https://images.pexels.com/photos/2124728/pexels-photo-2124728.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 22,
    image:
      "https://images.pexels.com/photos/2377658/pexels-photo-2377658.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 23,
    image:
      "https://images.pexels.com/photos/2647744/pexels-photo-2647744.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 24,
    image:
      "https://images.pexels.com/photos/2377658/pexels-photo-2377658.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 25,
    image:
      "https://images.pexels.com/photos/2647744/pexels-photo-2647744.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 26,
    image:
      "https://images.pexels.com/photos/2124728/pexels-photo-2124728.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 27,
    image:
      "https://images.pexels.com/photos/2377658/pexels-photo-2377658.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    id: 28,
    image:
      "https://images.pexels.com/photos/2647744/pexels-photo-2647744.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
];

export default ImageData;
